export const LineTypeName: string = "LINE";
export const OutlineTypeName: string = "OUTLINE";
